export const CONSULTANTS_SUCCESS_PHONE = {
  display: "+1 581-333-3447",
  e164: "+15813333447",
  tel: "tel:+15813333447",
};
